import { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'
import { useAuthContext } from '~/common/context/auth/auth-context'

function formatTimeRemaining(ms) {
  if (ms <= 0) return '0:00:00'

  const totalSeconds = Math.floor(ms / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

export const TicketStatus = ({ collapsed = false }) => {
  const { ticketInfo } = useAuthContext()
  const [timeRemaining, setTimeRemaining] = useState(null)

  useEffect(() => {
    // If expiresAt is missing, no timer should be shown
    if (!ticketInfo?.expiresAt) return

    function updateTime() {
      const now = new Date()
      const remaining = ticketInfo.expiresAt.getTime() - now.getTime()
      setTimeRemaining(Math.max(0, remaining))
    }

    updateTime()
    const interval = setInterval(updateTime, 1000)

    return () => clearInterval(interval)
  }, [ticketInfo?.expiresAt])

  if (!ticketInfo || timeRemaining === null) {
    return null
  }

  const ticketUrl = `${window.location.origin}/login?ticket=${ticketInfo.ticketId}`
  const isExpired = timeRemaining <= 0

  if (collapsed) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <QRCodeSVG
          value={ticketUrl}
          size={40}
          level="L"
          style={{ opacity: isExpired ? 0.5 : 1 }}
        />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: 1,
        borderRadius: 1,
        bgcolor: 'action.hover',
        mx: 1,
      }}
    >
      <QRCodeSVG
        value={ticketUrl}
        size={75}
        level="M"
        style={{ opacity: isExpired ? 0.5 : 1 }}
      />

      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            color: 'text.secondary',
          }}
        >
          Demo Access
        </Typography>

        <Typography
          variant="body2"
          sx={{
            fontFamily: 'monospace',
            fontWeight: 500,
            color: isExpired ? 'error.main' : 'text.primary',
          }}
        >
          {isExpired ? 'Expired' : formatTimeRemaining(timeRemaining)}
        </Typography>

        <Typography
          variant="caption"
          sx={{ color: 'text.secondary', textAlign: 'center' }}
        >
          {isExpired ? 'Session ended' : 'Time remaining'}
        </Typography>
      </Box>

    </Box>
  )
}
